<template>
  <v-container>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <!-- Gate on branchId like the two Bangkok rows below. form.branch_id comes from
         a separate about request that lands after the page is revealed, so the
         carousel used to be inserted on top of content that was already visible. -->
    <v-row v-if="serviceBangkokSlide && serviceBangkokSlide.length > 0 && branchId === 1" class="mb-3">
      <v-col>
        <ImageCarousel :images="serviceBangkokSlide" />
      </v-col>
    </v-row>
    <v-row class=" mt-10 row  " v-if="branchId === 1">
      <v-col class="text-center">
        <div class="header bold text-tcdc-green mb-2">“ เช่าพื้นที่จัดกิจกรรม @TCDC Bangkok “</div>
        <div class="text-tcdc-green">13 พื้นที่แห่งความคิดสร้างสรรค์</div>
        <GreenButton label="Book Now" @onPress="onBooking" class="mt-10"></GreenButton>

      </v-col>
    </v-row>
    <v-row class="row mt-10 d-flex justify-content-md-center" v-if="branchId === 1">
      <v-row class="col-lg-10">
        <div v-for="(item, index) in serviceIcon" :key="index"
          class="text-center col-sm-6 col-6 col-md-3 cursor-pointer" v-on:click="onVenueHireType(item.VentureHireType)">
          <img :src=item.imgUrl alt="" class="w-100">
          <!-- <div class=" text-tcdc-green bold">{{ item.contentTh }}</div> -->
          <div class=" text-tcdc-green bold" style="    font-size: 1.5vm;">{{ item.contentEn }}</div>
        </div>
      </v-row>
      <br />
    </v-row>
    <v-row class="mt-10">
      <v-col>
        <span class="header bold text-tcdc-green">{{ $t('venueHire.venueHireAt') }}</span>
        <VentureHire :sortBy="this.sortBy" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ServiceExpandable from "../../components/expandables/ServiceExpandable";
import { mapState } from 'vuex';
import Membership from "../../components/member_layouts/Membership";
import VentureHire from "../../components/venture_hire/VentureHire";
import { BreadcrumbUtil } from "@/util/BreadcrumbUtil";
import ImageCarousel from "../../components/carousels/ImageCarousel";
import GreenButton from "../../components/buttons/GreenButton.vue";
import Loading from 'vue-loading-overlay';

export default {
  async created() {
    this.getVenueHireByBranch();
    this.items = BreadcrumbUtil.setServiceItem(
      this.items,
      this.branchId,
      this.branchName,
      this.allBranches,
      this.lang
    )
    if (this.$route.params.branch) {
      let params = { branch_id: 0, lang: this.lang };
      let allBranch = [...this.allBranches];
      let all = true;
      allBranch.shift();
      for (const b of allBranch) {
        if (this.$route.params.branch === b.tag_name) {
          params.branch_id = b.branch_id;
          if (this.$route.params.branch === 'mini-tcdc') {
            await this.$store.dispatch('Branch/getMiniByBranch', params);
            all = false;
            break;
          }
          this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
          this.$store.dispatch("Branch/getBranchById", params.branch_id);
          all = false;
          break;
        }
      }
      if (all) {
        let params = { branch_id: 0, lang: this.lang };
        this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
      }
    } else {
      if (this.branchId !== 0) {
        let params = { branch_id: 0, lang: this.lang };
        this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
        this.$store.dispatch("Branch/getBranchById", params.branch_id);
      }
    }
    if (this.$route.params.branch !== this.tagName) {
      this.$store.dispatch("About/getAboutById", {
        id: this.branchId,
        lang: this.lang
      }).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("About/setFormAbout", res.result);
        } else {
          console.log('data not found');
        }
      });
      await this.$store.dispatch("Branch/getBranchById", this.branchId);
      await this.$store.dispatch("About/getAboutAllMenu", { branch_id: this.branchId, lang: this.lang });
    }
    this.$store.dispatch("About/getAboutById", {
      id: this.branchId,
      lang: this.lang
    }).then(res => {
      if (res.response_code == 200) {
        this.$store.dispatch("About/setFormAbout", res.result);
      } else {
        console.log('data not found');
      }
    });
  },
  mounted() {
    if (!window.location.href.includes("reloaded")) {
      const randomParam = new Date().getTime();
      window.location.href = `${window.location.href}${window.location.href.includes("?") ? "&" : "?"}reloaded=${randomParam}`;
    }
    this.$nextTick(() => {
      if (this.$route.hash) {
        let roomType
        switch (this.$route.hash) {
          case "#auditorium":
            roomType = 2
            break
          case "#production":
            roomType = 1
            break
          case "#exhibition":
            roomType = 4
            break
          case "#meeting":
            roomType = 3
            break
        }
        if (roomType) {
          setTimeout(() => {
            this.onVenueHireType(roomType);
          }, 1000)
        }
      }
    })
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      lang: state => state.Branch.lang,
      branchId: state => state.Branch.branch_id,
      form: state => {
        return state.About.form || {};
      },
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function () {
      this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchChanged,
        this.allBranches,
        this.lang
      )

      this.$store.dispatch("About/getAboutById", {
        id: this.branchId,
        lang: this.lang
      }).then(async res => {
        // console.log('getAboutById', res.result)
        if (res.response_code === 200) {
          await this.$store.dispatch("About/setFormAbout", res.result);

        } else {
          console.log('data not found');
        }
      })
    }
  },
  data: () => ({
    isLoading: false,
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        // href: "breadcrumbs_dashboard",
        to: "/home/:branch"
      },
      {
        text: "SERVICE",
        disabled: false,
        to: "/:branch/service"
      },
      {
        text: "SPACE RENTALS",
        disabled: true,
        // href: "breadcrumbs_link_1",
      }
    ],
    serviceIcon: [
      {
        VentureHireType: 2,
        imgUrl: "/images/Auditorium Space_icon1.png",
        contentTh: "พื้นที่สำหรับจัดเสวนาและบรรยาย",
        contentEn: "Auditorium Space"
      },
      {
        VentureHireType: 1,
        imgUrl: "/images/Production-Space-icon2.png",
        contentTh: "พื้นที่สำหรับถ่ายทำ",
        contentEn: "Production Space"
      },
      {
        VentureHireType: 4,
        imgUrl: "/images/Exhibition-Space-icon3.png",
        contentTh: "พื้นที่สำหรับจัดนิทรรศการ",
        contentEn: "Exhibition Space"
      },
      {
        VentureHireType: 3,
        imgUrl: "/images/Meeting-Room-icon4.png",
        contentTh: "ห้องประชุม",
        contentEn: "Meeting Room"
      },
    ],
    serviceBangkokSlide: [

    ],
    sortBy: 0
  }),
  components: {
    VentureHire,
    ImageCarousel,
    GreenButton
  },
  methods: {
    onBooking() {
      // this.$emit('onBooking');
      this.$vuetify.goTo('#contact-venuehire');
    },
    onVenueHireType(sortBy) {
      // this.$emit('onVenueHire');
      // console.log('onVenueHireType')
      this.$vuetify.goTo('#venueHireType');
      this.sortBy = sortBy;
    },
    async getVenueHireByBranch() {
      let lang = this.lang;
      let id = 1;
      console.log('getVenueHireByBranch', id);
      try {
        let res = await this.$store.dispatch("VenueHire/onGetVenueHire", { lang: lang, branch_id: id });
        if (res) {
          if (id === 1) {
            this.serviceBangkokSlide = res.slide_images
          } else {
            this.serviceBangkokSlide = res.slide_images
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
